<template>
  <v-form ref="filterForm" @submit.prevent="submitFilter()" class="filter">
    <v-row dense>
      <v-col cols="12" md="3">
        <v-select
            v-model="currentStatus"
            :label="$t('status')"
            :items="getStatus()"
            item-text="label"
            item-value="value"
            @change="filterStatus"
            dense
            outlined
        />
      </v-col>

      <v-col cols="12" md="7">
        <v-text-field
          v-model="filter"
          :label="$t('filter')"
          outlined
          dense
          clearable
        />
      </v-col>
      <v-col cols="12" md="1">
        <v-btn depressed color="#D8D8D8" :block="$vuetify.breakpoint.xsOnly" type="submit">
          <v-icon> mdi-magnify </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <TLoading v-model="loading" />
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import mixinOrderStatus from '@/mixins/mixinOrderStatus'
import _ from "lodash";
import config from '@/config'

export default {
  name: 'ListOrderItemsFiltersComponent',
  mixins: [mixinOrderStatus],
  data() {
    return {
      path: 'orders',
      filter: '',
      originalProducts: [],
      currentStatus: '',
      status: [],
      loading: false,
    }
  },
  computed: {
    ...mapGetters('ordersStore', ['getFilters', 'getDetailsList', 'getData'])
  },
  methods: {
    filterStatus() {
      if (this.originalProducts.length === 0) {
        this.originalProducts = this.getData
      }

      this.ordersStore({
        ...this.originalProducts,
        ITENS: this.currentStatus ? this.originalProducts.ITENS.filter(item => {
          return item.STATUS === this.currentStatus
        }) : this.originalProducts.ITENS
      })
    },
    getStatus() {
      if (this.getDetailsList.length === 0 || this.status.length > 0) {
        return this.status
      }

      let status = '';

      if(config.VUE_APP_COUNTRY == 'UY'){
        status = this.getDetailsList.map(item => item.STATUS_HEADER)
      }else{
        status = this.getDetailsList.map(item => item.STATUS)
      }

      

      this.status = [
          {
            label: 'Todos',
            value: ''
          },
          ..._.uniq(status).map(item => {
            let newStatus = this.getNewStatus(item)

            return {
              label: newStatus ? _.capitalize(newStatus.label) : '',
              value: item
            }
          })
      ]

      return this.status
    },
    submitFilter() {
      this.setSearch(this.filter)
      this.filterStatus()
    },
    ...mapActions({
      setSearch(dispatch, payload) {
        return dispatch('ordersStore/setSearch', payload)
      },
      ordersStore(dispatch, payload) {
        return dispatch('ordersStore/setFilterItems', payload)
      }
    }),
  },
}
</script>
